module.exports = __webpack_public_path__ + "img/porre.03b10b1e.jpg";